import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { umsDocumentCard } from './components/document-card/ums-document-card.component'
import { documentSearchConfig } from './containers/document-search/document-search.component'
import { customerDocumentsComponent } from './containers/documents/documents.component'
import { customerDocumentsAbtractState, customerDocumentsRunblock, customerDocumentsState } from './documents.states'
import { documentTypeFilter } from './filters/document-type.filter'

const documentsModule = {
  components: { customerDocumentsComponent, umsDocumentCard },
  states: [customerDocumentsState, customerDocumentsAbtractState],
  configBlocks: [documentSearchConfig],
  runBlocks: [customerDocumentsRunblock],
  filters: { documentTypeFilter },
}

loadNg1Module(ngmodule, documentsModule)



// WEBPACK FOOTER //
// ./app/documents/documents.module.js